import { StyleSheet, View } from 'react-native';

import PointsIcon from 'components/icons/loyalty-points-icon';
import { primitive } from 'styles/constants';

export const CrownIcon = () => {
  return (
    <View style={styles.container}>
      <View style={styles.crownIconContainer}>
        {/* @ts-ignore - style type mismatch on web */}
        <PointsIcon style={styles.pointsIcon} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    left: 0,
    right: 0,
    top: -22,
  },
  crownIconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 52,
    height: 52,
    borderRadius: 26,
    backgroundColor: primitive.$white,
  },
  pointsIcon: {
    marginTop: -10,
    width: 26,
  },
});
